module.exports = __webpack_public_path__ + "img/kba.6656037f.png";